import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface UserStore {
  lastIntroPlayDate: string | null
  setLastIntroPlayDate: (date: string) => void
}

type IntroPreference = Pick<UserStore, 'lastIntroPlayDate'>

export const useUser = create<UserStore>()(
  persist(
    (set) => ({
      lastIntroPlayDate: null,
      setLastIntroPlayDate: (date) => set({ lastIntroPlayDate: date }),
    }),
    {
      name: 'user-store',
      partialize: (state) => ({ lastIntroPlayDate: state.lastIntroPlayDate }),
      // This optional preference must never block page startup when storage is denied.
      storage: {
        getItem: (name) => {
          try {
            return createJSONStorage<IntroPreference>(() => localStorage)?.getItem(name) ?? null
          } catch {
            return null
          }
        },
        setItem: (name, value) => {
          try {
            createJSONStorage<IntroPreference>(() => localStorage)?.setItem(name, value)
          } catch {
            // The in-memory preference still works without browser persistence.
          }
        },
        removeItem: (name) => {
          try {
            createJSONStorage<IntroPreference>(() => localStorage)?.removeItem(name)
          } catch {
            // Clearing an optional preference is best-effort too.
          }
        },
      },
      skipHydration: true,
    },
  ),
)
